import { Field } from 'serialize-ts';
import { HttpErrorResponse } from '@angular/common/http';

export abstract class BaseHttpError {
  @Field()
  type: string;

  @Field()
  title: string;

  @Field()
  status: number;

  @Field()
  detail: string;

  sourceError?: HttpErrorResponse;
}
